module.exports = {
  socketIo: "https://api2.rechart.eu"
};